import "./SafetySecurityProducts.module.css";
import Header from "@/reusable_sections/Header";
import HeroThreat from "./sections/HeroThreat";
import Catalog from "./sections/Catalog";
import ApplicationSolutions from "./sections/ApplicationSolutions";
import Footer from "@/reusable_sections/Footer";
export default function SafetySecurityProductsPage() {
  return <div>
      <Header />
      <HeroThreat />
      <Catalog />
      <ApplicationSolutions />
      <Footer />
    </div>;
}